import React from 'react';
import SEO from '../components/SEO';
import PageHeader, { PageContainer } from '../components/PageHeader';
import TabStrip from '../features/portfolio/components/TabStrip';
import PortfolioView from '../features/portfolio/components/PortfolioView';
import TranscriptPrintView from '../features/portfolio/components/TranscriptPrintView';
import { useLearnerPortfolio } from '../features/portfolio/hooks/useLearnerPortfolio';
import { useAuth } from '../auth/AuthProvider';
import { firstNameFromUser } from '../utils/greeting';

const INSIGHTS_TABS = [
  { to: '/insights', label: 'Analytics' },
  { to: '/insights/portfolio', label: 'Transcript' },
];

export default function InsightsPortfolioPage() {
  const { data, loading, error, reload } = useLearnerPortfolio();
  const { user } = useAuth();
  const firstName = firstNameFromUser(user);

  // If the stub returned displayName === null, fill from auth so the header
  // reads "Zac Williams" rather than "Your learning record" — makes the page
  // feel personal even under the stub. Also thread the auth user's photo
  // through so the transcript avatar mirrors the sidebar avatar instead of
  // showing initials. Fallback chain matches Layout.jsx for consistency.
  const primaryPhotoURL =
    user?.photoURL || user?.providerData?.[0]?.photoURL || null;
  const portfolio = data
    ? {
        ...data,
        displayName: data.displayName || user?.displayName || null,
        photoUrl: data.photoUrl || primaryPhotoURL,
      }
    : null;

  return (
    <>
      <SEO title="Transcript" path="/insights/portfolio" noindex />
      <PageContainer>
        <div className="no-print">
          {/* Same header as the Analytics tab so the two read as one screen
              with a tab strip, per redesign 1d. */}
          <PageHeader
            title="Your learning"
            subtitle="Habits, strengths, and the record your work has built so far."
          />
          <TabStrip tabs={INSIGHTS_TABS} />
          <PortfolioView
            portfolio={portfolio}
            loading={loading}
            error={error}
            onReload={reload}
            subjectFallbackName="Your"
            onExport={() => window.print()}
          />
        </div>
        <TranscriptPrintView portfolio={portfolio} studentLabel={firstName} />
      </PageContainer>
    </>
  );
}
